import { useEffect, useState } from "react"
import { Designation } from "../../../types/dataModel"
import useFetch from "../../../hooks/useFetch"
import { API } from "../../../common/Constants"
import PreLoader from "../../../core/common/preLoader"
import { getAPIHeaders, isNotEmpty } from "../../../common/Utils"

interface Props {
    designation: any
    onSuccess: ()=> void
}

const ModifyDesignation = ({designation, onSuccess}:Props) => {
    const [formDepatment, setFormDesignation] = useState<Designation | undefined>(designation)
    const [msgBox, setMsgBox] = useState<any>({
      msg: "",
      error: false
    });
    const {isLoading, error, data, status, callFetch } = useFetch();

    useEffect(()=>{
        setFormDesignation(designation)
    },[designation])

    const reset = () => {
      resetMsgBox()
    }

    const resetMsgBox = () => {
      setMsgBox({
        msg: "",
        error: false
      })
    }

    useEffect(() => {
              if(data && status && status < 299){
                setMsgBox({msg: "Updated successfully", error: false})
                onSuccess()
              }
    }, [status]);
        
        
    useEffect(() => {
            if(error){
              if(error.response?.data){
                setMsgBox({msg: error.response?.data, error: true})
              } else{
                setMsgBox({msg: 'Something went wrong please try again later.', error: true})
              }
            }
    }, [error]);
        
    const renderMsgBox = () => {
      return (
        <div>
        { msgBox?.msg  
            ?
            msgBox?.error
            ?
              <>
                <i className="ti ti-alert-triangle text-danger" />  
                <span className='text-danger'> {msgBox?.msg} </span> 
              </> 
            :
              <>
                <i className="ti ti-thumb-up text-success" />  
                <span className='text-success'> {msgBox?.msg} </span> 
              </> 
            : <></>
        }
      </div>
      )
    }

    const handleSubmit = (event:any) => {
          event.preventDefault()
          if(!isNotEmpty(formDepatment?.name)){
            setMsgBox({msg: "Please provide name", error: true})
          } else if(!isNotEmpty(formDepatment?.description)){
            setMsgBox({msg: "Please provide description", error: true})
          } else {
            setMsgBox({msg:"",error: false})
            callFetch(API.DESIGNATION,
                  'PUT',
                  getAPIHeaders(),
                  null,
                  {
                      id: formDepatment?.id,
                      name: formDepatment?.name,
                      description: formDepatment?.description,
                  }
              );
          }
    }

    return (
        <div className="modal-dialog modal-dialog-centered modal-md"
        data-bs-backdrop="static"
        data-bs-keyboard="false">
          <PreLoader showLoader={isLoading} />
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Designation</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={reset}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Designation Name <span className="text-danger"> *</span></label>
                      <input
                        type="text"
                        className="form-control"
                        value={formDepatment?.name}
                        onChange={(e)=>{
                          setFormDesignation({
                            ...formDepatment,
                            name: e.target.value
                          })
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Description <span className="text-danger"> *</span></label>
                      <input
                        type="text"
                        className="form-control"
                        value={formDepatment?.description}
                        onChange={(e)=>{
                          setFormDesignation({
                            ...formDepatment,
                            description: e.target.value
                          })
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer"  style={{ justifyContent: "space-between"}}>
                {renderMsgBox()}
                <div>
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                    onClick={reset}
                  >
                    Cancel
                  </button>
                  <button type="button" 
                    className="btn btn-primary"
                    onClick={handleSubmit}>
                    Save Designation
                  </button>
                </div>
              </div>
            </form>
          </div>
      </div>
    )
}

export default ModifyDesignation